import enumBase from './EnumBase';

export default class BulkSendEntryStatus extends enumBase {
  static PENDING = 'pending';
  static PROCESSING = 'processing';
  static COMPLETED = 'completed';
  static FAILED = 'failed';

  static AWAITING_SIGNATURE = 'awaitingSignature';
  static SIGNED = 'signed';
  static CANCELLED = 'cancelled';
  static EXPIRED = 'expired';
  static HALTED = 'halted';

  static values = [this.PENDING, this.PROCESSING, this.COMPLETED, this.FAILED];

  static getAllStatusTranslated(i18n) {
    return this.values.map((item) => ({
      value: item,
      label: this.getText(item, i18n),
    }));
  }

  static getText(value, i18n) {
    return i18n.t(`bulkSendDetails.recipientStatus.${value}`) || value;
  }
}
